// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","585":"ed8621fd","783":"44e3f5a0"}[chunkId] + ".chunk.js";
};